export const scrollToRef = ref => {
    const top =
        ref.current.offsetTop + ref.current.offsetHeight > window.innerHeight
            ? ref.current.offsetTop + ref.current.offsetHeight
            : ref.current.offsetTop;

    return window.scrollTo({
        top,
        behavior: "smooth"
    });
};

export function renderPrice(price, options) {
    const locale = options?.locale ?? "nl-NL";
    const currency = options?.currency ?? "EUR";

    if (price === 0 && !options?.canBeZero) {
        return "Gratis";
    }

    return price?.toLocaleString(locale, {
        style: "currency",
        currency
    });
}

export const renderFinalPrice = (value, options) => {
    const canBeZero = options?.canBeZero ? options.canBeZero : false;
    const useDash = options?.useDash ? options.useDash : false;
    const locale = options?.locale ? options.locale : "nl-NL";
    let string;
    const amount = parseFloat(value);
    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: "EUR"
    });

    string = formatter.format(amount);

    if (useDash && canBeZero) {
        string = string.replace(/,00/, ",-");
    }

    if (amount === 0 && !canBeZero) {
        string = "Gratis";
    }

    return string;
};

export const isExternalLink = url => {
    return !url.startsWith("/");
};

export function generateQueryString(object, encode = false) {
    if (encode) {
        return Object.entries(object)
            .map(key => key.map(encodeURIComponent).join("="))
            .join("&");
    }

    return Object.keys(object)
        .map(key => `${key}=${object[key]}`)
        .join("&");
}
